import * as React from 'react';
import { ITeam } from '../../../../data/types';
import { Row } from '../../../layout/Row';
import { SearchInput } from '../../../shared/form/SearchInput';
import { Controls, ControlsLeftSide, ControlsRightSide } from '../Controls';
import { ManageTeamPopup } from './ManageTeamPopup';

interface IProps {
  onSearch: (search: string) => void;
  search: string;
  loading: boolean;
  teams: ITeam[];
  isAdmin: boolean;
}

export const TeamControls = (props: IProps): React.ReactElement => {
  const clearSearch = (): void => props.onSearch('');
  return !props.loading ? (
    <Controls>
      <ControlsLeftSide>
        <Row>
          <SearchInput
            value={props.search}
            onClear={clearSearch}
            onChange={props.onSearch}
            style={{ margin: '0px' }}
          />
        </Row>
      </ControlsLeftSide>
      <ControlsRightSide>
        {props.isAdmin && <ManageTeamPopup />}
      </ControlsRightSide>
    </Controls>
  ) : null;
};
